// Aviso regulatório (Medida Provisória): enquanto `enabled`, o modal de
// depósito vira um aviso de "Depósitos suspensos" — sem formulário, sem
// métodos e sem o auto-submit do deeplink ?open=pix&value=.
//
// Pra reativar os depósitos: `enabled: false`. É build-time, então só vale
// depois de build + deploy.
//
// O bloqueio é só visual: /wallet/add-credit continua indo pro backend, que
// precisa aplicar o bloqueio de verdade.
export const depositSuspensionNotice = {
  enabled: true,
  title: 'Depósitos suspensos',
  message:
    'Em cumprimento à nova Medida Provisória, não estamos mais aceitando depósitos nem apostas. Os saques continuam disponíveis até as 23h59 do dia 5/10.',
  reassurance: 'Fique tranquilo: seu saldo está seguro na ApostaTudo.',
  dismissLabel: 'Entendi',
} as const;

export function isDepositSuspended(): boolean {
  return depositSuspensionNotice.enabled;
}

// Textos que o StepSuspended renderiza. O aviso de depósito acima já tem esse
// formato; os da pausa do site (abaixo) reusam o mesmo visual.
export type SuspensionNotice = {
  title: string;
  message: string;
  reassurance: string;
  dismissLabel: string;
};

export type SiteSuspensionVariant =
  | 'home'
  | 'register'
  | 'games'
  | 'checkin'
  | 'roulette';

const SITE_SUSPENSION_REASSURANCE =
  'Fique tranquilo: seu saldo está seguro, e os saques e o suporte continuam funcionando normalmente.';

// Pausa das operações (Medida Provisória), aberta pelo AnnouncementModal: na
// home, no cadastro, em /games e /sports, no check-in diário e na roletinha.
// O depósito continua no aviso do próprio modal de depósito
// (depositSuspensionNotice).
export const siteSuspensionNotices: Record<
  SiteSuspensionVariant,
  SuspensionNotice
> = {
  home: {
    title: 'Operações pausadas',
    message:
      'Em cumprimento à nova Medida Provisória, a ApostaTudo pausou temporariamente suas operações.',
    reassurance: SITE_SUSPENSION_REASSURANCE,
    dismissLabel: 'Entendi',
  },
  register: {
    title: 'Cadastros pausados',
    message:
      'Em cumprimento à nova Medida Provisória, não estamos aceitando novos cadastros no momento.',
    reassurance:
      'Já é cliente? Seu saldo está seguro, e os saques e o suporte continuam funcionando normalmente.',
    dismissLabel: 'Entendi',
  },
  games: {
    title: 'Apostas pausadas',
    message:
      'Em cumprimento à nova Medida Provisória, as apostas e os jogos estão temporariamente pausados.',
    reassurance: SITE_SUSPENSION_REASSURANCE,
    dismissLabel: 'Entendi',
  },
  checkin: {
    title: 'Check-in pausado',
    message:
      'Em cumprimento à nova Medida Provisória, o check-in diário está temporariamente pausado.',
    reassurance: SITE_SUSPENSION_REASSURANCE,
    dismissLabel: 'Entendi',
  },
  roulette: {
    title: 'Roletinha pausada',
    message:
      'Em cumprimento à nova Medida Provisória, a roletinha está temporariamente pausada.',
    reassurance: SITE_SUSPENSION_REASSURANCE,
    dismissLabel: 'Entendi',
  },
};
